// extracted by mini-css-extract-plugin
export default {"loadingContainer":"ProfileMuro_loadingContainer__4Dm3W","list":"ProfileMuro_list__NEyuK"};